import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-vst",
  "use": "icon-vst-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-vst\"><path d=\"M968.704 135.168h-430.08v752.64h430.08c14.336 0 26.624-12.288 26.624-26.624V162.816c0-15.36-11.264-27.648-26.624-27.648z\" fill=\"#7986CB\" /><path d=\"M592.896 995.328L28.672 888.832V135.168L592.896 28.672v966.656z\" fill=\"#3949AB\" /><path d=\"M250.88 689.152l-92.16-337.92 63.488-5.12 65.536 263.168h4.096l68.608-275.456 74.752-6.144-108.544 368.64-75.776-7.168z\" fill=\"#FFFFFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol